const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4368 2.83302C17.2057 2.28685 18.998 3.60929 18.998 5.46062V7.32497C20.7097 7.67242 21.998 9.18574 21.998 11C21.998 12.8142 20.7097 14.3275 18.998 14.6749V16.5393C18.998 18.3906 17.2057 19.7131 15.4368 19.1669L13.2837 18.5021C12.7686 19.9564 11.3812 21 9.74805 21C7.67698 21 5.99805 19.321 5.99805 17.25V16.2526L3.93676 15.6162C2.78417 15.2603 1.99805 14.1949 1.99805 12.9886V9.01131C1.99805 7.80504 2.78417 6.73958 3.93676 6.38371L6.51229 5.5885C6.52316 5.58487 6.53413 5.58148 6.54521 5.57833L15.4368 2.83302ZM7.49805 16.7158V17.25C7.49805 18.4926 8.50541 19.5 9.74805 19.5C10.7044 19.5 11.5232 18.9029 11.8484 18.059L7.49805 16.7158ZM20.498 11C20.498 11.9796 19.8719 12.813 18.998 13.1219V8.87798C19.8719 9.18686 20.498 10.0203 20.498 11ZM6.00024 7.31647V14.6834L4.37928 14.183C3.85538 14.0212 3.49805 13.5369 3.49805 12.9886V9.01131C3.49805 8.46301 3.85538 7.97871 4.37928 7.81695L6.00024 7.31647Z"
      fill="currentColor"
    />
  </svg>
)
export default SVGComponent
